import { pasteCopy } from '../../../../store/actions/nodeMenu/pasteCopy';
import { pasteMove } from '../../../../store/actions/nodeMenu/pasteMove';
import { trackUIInteraction } from '../../../../utils/analyticsEvents';
import { isPastable } from '../../../../utils/command';

export function getCatalogActions(
  { canPaste },
  { directive, dispatch, isCopy, targetNodeItem, sourceNodeItems, tree },
) {
  const sourceNode = sourceNodeItems?.[0]?.node;

  if (!sourceNode) {
    return {};
  }

  if (
    canPaste({ nextParent: targetNodeItem.node, node: sourceNode }) &&
    isPastable(directive)
  ) {
    return {
      pasteAction: isCopy
        ? async (callback) => {
            await dispatch(pasteCopy(tree, targetNodeItem));
            trackUIInteraction('paste_category', {
              id: targetNodeItem.node.id,
              type: sourceNode.type,
            });
            callback();
          }
        : async (callback) => {
            await dispatch(pasteMove(tree, targetNodeItem));
            trackUIInteraction('paste_category', {
              id: targetNodeItem.node.id,
              type: sourceNode.type,
            });
            callback();
          },
    };
  }

  return {};
}
